<template>
    <div
        class="app-container clearfix"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <!-- <el-row style="padding-bottom: 15px;">
      <el-col :span="24">
        <h3 class="headtitle">科目类别维护</h3>
        <span>科目类别</span>
      </el-col>
    </el-row> -->
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <el-row>
                        <el-col>
                            <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-plus"
                                class="pull-right"
                                @click="addInfo"
                                v-if="isGranted('Pages.SubjectTypes.Create')"
                                >新增</el-button
                            >
                        </el-col>
                    </el-row>
                    <el-table
                        :data="tableData"
                        size="mini"
                        style="width: 100%; margin-top: 10px"
                        border
                    >
                        <el-table-column
                            label="操作"
                            width="200"
                            v-if="
                                isGranted('Pages.SubjectTypes.Delete') ||
                                isGranted('Pages.SubjectTypes.Edit')
                            "
                        >
                            <template slot-scope="scope">
                                <el-tooltip content="编辑" placement="bottom">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-edit"
                                        circle
                                        @click="
                                            editRow(scope.row.subjectType.id)
                                        "
                                        size="mini"
                                        v-if="
                                            isGranted('Pages.SubjectTypes.Edit')
                                        "
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip content="删除" placement="bottom">
                                    <el-button
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        @click="
                                            deleteEntity(
                                                scope.row.subjectType.id
                                            )
                                        "
                                        size="mini"
                                        v-if="
                                            isGranted(
                                                'Pages.SubjectTypes.Delete'
                                            )
                                        "
                                    ></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="科目类别名称"
                            align="center"
                        >
                            <template slot-scope="scope">{{
                                scope.row.subjectType.subjectTypeName
                            }}</template>
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="所属科目"
                            align="center"
                        >
                            <template slot-scope="scope">{{
                                scope.row.subjectType.moduleMark
                            }}</template>
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="科目属性"
                            align="center"
                        >
                            <template slot-scope="scope">{{
                                scope.row.subjectType.typeProp
                            }}</template>
                        </el-table-column>
                    </el-table>
                    <pagerBar
                        ref="refPagerBar"
                        :apiURL="subjectTypeUrl"
                        :GetData="initData"
                        :queryParam="queryParams"
                        :errorFunc="closeOpenloading"
                    ></pagerBar>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog
            v-el-drag-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="38%"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form
                label-width="110px"
                :model="formLabel"
                :rules="rules"
                ref="SubjectTypeEditForm"
            >
                <el-form-item label="科目类别名称" prop="subjectTypeName">
                    <el-input
                        v-model="formLabel.subjectTypeName"
                        placeholder="请输入科目类别名称"
                    ></el-input>
                </el-form-item>
                <el-form-item label="所属模块" prop="moduleMark">
                    <el-select
                        v-model="formLabel.moduleMark"
                        placeholder="请选择所属模块"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in Modules"
                            :key="item.mark"
                            :label="item.moduleName"
                            :value="item.mark"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                    label="科目类别属性"
                    prop="moduleMark"
                    v-show="
                        formLabel.moduleMark == 'SCM' ||
                        formLabel.moduleMark == 'Z5' ||
                        formLabel.moduleMark == 'SCM8'
                    "
                >
                    <el-radio-group v-model="formLabel.typeProp">
                        <el-radio-button
                            v-for="item in TypeProps"
                            :key="item"
                            :label="item"
                            :value="item"
                        ></el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="SaveEntity()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
import pagerBar from '@/views/pager/pagerBar'
export default {
    data() {
        return {
            //TODO
            openloading: true,
            dialogVisible: false, // 弹窗显示
            tableData: [],
            moduleListUrl:
                config.BASE_Middle_API + 'SubjectTypes/GetModuleList',
            //科目类别列表数据获取
            subjectTypeUrl: config.BASE_Middle_API + 'SubjectTypes/GetAll',
            //新增or修改
            createOrEditUrl:
                config.BASE_Middle_API + 'SubjectTypes/CreateOrEdit',
            //删除
            deleteUrl: config.BASE_Middle_API + 'SubjectTypes/Delete',
            //得到信息实体
            GetEntityUrl:
                config.BASE_Middle_API + 'SubjectTypes/GetSubjectTypeForEdit',
            title: '新增科目类别',
            operation: '',
            formLabel: {
                id: null,
                subjectTypeName: '',
                moduleMark: '',
                typeProp: ''
            },
            queryParams: { Filter: '' },
            rules: {
                subjectTypeName: [
                    {
                        required: true,
                        message: '请输入科目类别名称',
                        trigger: 'blur'
                    }
                ],
                moduleMark: [
                    {
                        required: true,
                        message: '请选择所属模块',
                        trigger: 'blur'
                    }
                ]
            },
            Modules: [],
            TypeProps: ['成本', '收入']
        }
    },
    components: {
        pagerBar
    },
    methods: {
        closeOpenloading() {
            this.openloading = false
        },
        getModules() {
            const _this = this
            AjaxHelper.get(_this.moduleListUrl)
                .then(function (response) {
                    if (response.success) {
                        _this.Modules = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        //新增科目类别
        addInfo() {
            this.clearformLabel()
            this.dialogVisible = true
            this.title = '新增科目类别'
            this.formLabel.typeProp = '成本'
            this.getModules()
        },
        clearformLabel() {
            const _this = this
            _this.formLabel.id = null
            _this.formLabel.subjectTypeName = ''
            _this.formLabel.moduleMark = ''
        },
        initData(d) {
            const _this = this
            _this.tableData = d

            _this.openloading = false
        },
        //编辑
        editRow(id) {
            const _this = this
            _this.title = '编辑科目类别'
            _this.operation = 'edit'
            _this.getModules()
            let confirmData = { Id: id }

            AjaxHelper.get(_this.GetEntityUrl, confirmData)
                .then(function (response) {
                    if (response.success) {
                        _this.dialogVisible = true
                        _this.formLabel = response.result.subjectType
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        deleteEntity(deleteId) {
            const _this = this
            this.$confirm('此操作将删除该科目类别, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            })
                .then(() => {
                    AjaxHelper.delete(_this.deleteUrl, {
                        Id: deleteId
                    })
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                })
                                _this.Refresh()
                            }
                        })
                        .catch(function (error) {
                            // _this.$message({
                            //   type: "danger",
                            //   message: error
                            // });
                        })
                })
                .catch((e) => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        //保存基础资料档案
        SaveEntity() {
            const _this = this
            this.$refs['SubjectTypeEditForm'].validate((valid) => {
                let basicData = {}
                if (_this.operation == 'edit') {
                    basicData = _this.formLabel
                } else {
                    basicData = _this.formLabel
                }
                if (valid) {
                    AjaxHelper.post(_this.createOrEditUrl, basicData)
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '操作成功'
                                })
                                _this.pagesize = 1
                                _this.clearformLabel()
                                _this.Refresh()
                                _this.dialogVisible = !_this.dialogVisible
                            } else {
                                _this.$message({
                                    type: 'error',
                                    message: response.Messages[0]
                                })
                            }
                        })
                        .catch(function (error) {
                            _this.$message({
                                type: 'error',
                                message: error
                            })
                        })
                }
            })
        },
        Refresh() {
            this.$refs.refPagerBar.Refresh()
        },
        handleClose(done) {
            done()
        }
    }
}
</script>

<style scoped="scoped">
dt,
dd {
    margin: 0;
    padding: 0;
}
</style>
